import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  container: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    top: 0,
  },
  title: {
    alignSelf: 'center',
    backgroundColor: 'rgba(0,0,0,0.75)',
    borderRadius: 18,
    color: 'white',
    fontFamily: 'monospace',
    fontSize: 14,
    lineHeight: 9,
    marginTop: 4,
    paddingHorizontal: 16,
    paddingVertical: 6,
    position: 'absolute',
  },
  overCamera: {
    position: 'absolute',
  },
});
